const destinations = new Set(['/organizer', '/dashboard/events', '/mes-billets']);
const allowed = value => destinations.has(value) || /^\/(buy|direct|ceremonie)\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/.test(value || '');
export function authDestination(search = window.location.search) {
  const value = new URLSearchParams(search).get('next');
  return allowed(value) ? value : '/';
}
export function rememberAuthDestination(search) {
  sessionStorage.setItem('infoflow.auth.next', authDestination(search));
}
export function consumeAuthDestination() {
  const value = sessionStorage.getItem('infoflow.auth.next');
  sessionStorage.removeItem('infoflow.auth.next');
  return allowed(value) ? value : '/';
}

// Keep the organizer destination when an expired session sends the user to login.
export function expiredSessionLogin(pathname, search = '') {
  const next = allowed(pathname) ? pathname : authDestination(search);
  return '/login?expired=1' + (next !== '/' ? '&next=' + encodeURIComponent(next) : '');
}
